module.exports = require('./helpers/bundle-url').getBundleURL('aXMci') + "solar-panel.37fda076.png" + "?" + Date.now();